<template>
    <div class="feature">
        <div class="feature__box feature__box--first">
            <div class="feature__txt">
                <p class="feature__title txt--purple">Consult a doctor anytime, anywhere through video</p>
                <p class="feature__desc">Talk to a doctor now or schedule for later</p>
            </div>
            <div class="feature__img">
                <img src="/img/feature/consultation1.png" alt="feature consultation" class="consultation">
            </div>
        </div>
         <div class="feature__box feature__box--white">
            <div class="feature__txt">
                <p class="feature__title txt--purple">Conveniently buy medicines</p>
                <p class="feature__desc">Skip the lines at the pharmacy and get your medicines delivered to your door</p>
            </div>
            <div class="feature__img">
                <img src="/img/feature/delivery.png" alt="feature delivery" class="delivery">
            </div>
        </div>
        <div class="feature__box feature__box--last">
            <div class="feature__txt">
                <p class="feature__title txt--purple">Easily book clinic and lab schedules</p>
                <p class="feature__desc">Secure an appointment for face-to-face consultations and diagnostic tests</p>
            </div>
            <div class="feature__img">
                <img src="/img/feature/schedule.png" alt="feature schedule" class="schedule">
            </div>
        </div>
        <p class="feature__more">...and more to come!</p>
    </div>
</template>
<script>
export default {
  name: 'Feature',
};
</script>
